import { schema } from 'normalizr';
import { cardListSchema } from "./card";

export const weekSchema = new schema.Entity('weeks', {
    cards: cardListSchema,
});
export const weekListSchema = [ weekSchema ];



// WEBPACK FOOTER //
// ./src/schemas/week.js